export default {
    loading(state){
        return state.loading;
    },
    loaded(state){
        return state.loaded;
    },
    catalogs(state){
        return state.catalogs;
    }
}